<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="24" :sm="24" :lg="16">
      <el-button type="normal" @click.prevent="goBack" class="ml-20"><i class="el-icon-d-arrow-left"> 回上頁</i>
      </el-button>
    </el-col>
    <el-col :xs="24" :sm="24" :lg="8" style="text-align: right">
      <el-button v-if="basicForm.status === 'draft'" type="warning" @click.prevent="handleDraft">暫存 <i
          class="el-icon-s-claim"></i></el-button>
      <el-button v-if="basicForm.status === 'draft'" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
          class="el-icon-s-claim"></i></el-button>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
            <!--            <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
          </div>
          <div>
            <el-form :model="basicForm"
                     :rules="rules"
                     ref="dataForm"
                     label-width="100px">

              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填單人" prop="userObj.username" >
                    <el-input  readonly v-model="basicForm.userObj.username"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題" prop="title">
                    <el-input v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期" prop="startDate" >
                    <el-date-picker type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>        


              
            </el-form>

          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>工作日報</span>
            <el-button v-if="basicForm.status === 'draft'" style="float: right; padding: 5px 12px" 　type="primary"
                       @click.prevent="handleAdd" class="mr-20">新增日誌 <i class="el-icon-s-claim"></i></el-button>
          </div>
          <div>
            <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              
              <el-table-column label="說明" prop="notes">
              </el-table-column>

              <el-table-column label="附件" type="expand">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <ol>
                      <li v-for="f in scope.row.fileListDisplay" :key="f.id">
                        ({{f.fileNote}})<a :href="displayAvatar(f.fileRepo.uuid)">{{f.fileRepo.name}}</a>
                      </li>
                    </ol>
                  </el-form>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="200" v-if="basicForm.status === 'draft'">
                <template slot-scope="scope">
                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="handleDelete(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference">刪除 <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>


            </el-table>


          </div>
        </el-card>
      </el-main>
    </el-col>

    <!--    簽核紀錄-->
    <el-col :xs="24" :sm="24" :lg="24"　 v-if="basicForm.status !== 'draft'">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="historyTableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              <el-table-column label="時間" prop="updatedAt">
                <template slot-scope="scope">
                  {{ scope.row.updatedAt | fmtDateTime }}
                </template>
              </el-table-column>
              <el-table-column label="簽核人" prop="signerObj.username"></el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="備註" prop="notes">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="填寫工作日誌"
               :visible.sync="dialogFormVisible"
               :width="dw"
               @close="closeDialog">
      <el-form :model="form"
               :rules="dailyJobRule"
               ref="dailyJobRuleForm"
               label-width="100px">

        

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="說明" prop="result">
              <el-input type="textarea" rows="4" v-model="form.result" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-for="(btn, i) in btnCount" :key="i">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove"
                  :file-list="fileList">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>



      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save('dailyJobRuleForm')">確 定</el-button>
      </div>
    </el-dialog>
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'

export default {
  name: "TodoDetailEmpMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      dw: '',
      historyTableData: [],
      tableData: [],
      options: [],
      logTypeOptions: [{
        value: '補漆',
        label: '補漆'
      }, {
        value: '補缺',
        label: '補缺'
      }],
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        endDate: '',
        status: '',
        userObj:{}
      },
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      btnCount: 0,
      form: {
        id: '',
        mytodoId: '',
        logType: '',
        product: '',
        qty: '',
        result: '',
        progress: '',
        fileList: [],
        fileNotes: []
      },
      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      dailyJobRule: {
        logType: [{required: true, validator: checkName, trigger: 'change'}],
        product: [{required: true, validator: checkName, trigger: 'change'}],
        qty: [{required: true, validator: checkName, trigger: 'blur'}],
        result: [{required: true, validator: checkName, trigger: 'blur'}],
        progress: [{required: true, validator: checkName, trigger: 'blur'}],

      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    goBack() {
      this.$router.push('/daily/todo')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    save(formName) {
      // this.$refs[formName].validate(async valid => {
      //   console.log('valid:', valid)
      //   if (valid) {
      //       this.request.post("/todo/mgr/history", this.form).then(res => {
      //         if (res.code === '200') {
      //           this.dialogFormVisible = false
      //           this.loadHistoryData()
      //           this.showResult('success', '新增成功')
      //         } else {
      //           this.showResult('error', res.message)
      //         }
      //       })
      //   }
      // });

      
    },
    closeDialog() {
      this.$refs['dailyJobRuleForm'].resetFields()
      this.loadHistoryData()
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      // this.form.todoType = this.getTodoType()
    },
    loadHistoryData() {
      this.request.get("/todo/emp/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '日誌紀錄撈取失敗')
        }
      })
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '日誌簽核紀錄撈取失敗')
        }
      })
    },
    loadProducts() {
      this.request.get("/product/query?keyword=").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無商品名稱']
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },
    newUploadField() {
      this.btnCount++
    },
    handleDraft() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleSign() {
      // this.$refs['dataForm'].validate(async valid => {
        
      //   if (valid) {
      //     this.$confirm('送出簽核?', '提示', {
      //       confirmButtonText: '確定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }).then(() => {
      //       this.basicForm.status = "review"
      //       this.request.post("/todo/signoff", this.basicForm).then(res => {
      //         if (res.code === '200') {
      //           this.formDefault()
      //           this.showResult('success', '資料送簽核成功')
      //         } else {
      //           this.showResult('error', '資料送簽核失敗')
      //         }
      //       })
      //     }).catch(() => {

      //     });
      //   }
      // })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 680; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = defaultWidth + "px";
      }
    },
    handleDelete(id) {
      // this.request.delete("/todo/emp/history/" + id).then(res => {
      //   if (res.code === '200') {
      //     this.showResult('success', '資料刪除成功.')
      //     this.loadHistoryData()
      //   } else {
      //     this.showResult('error', '資料刪除失敗.')
      //   }
      // })
    },
  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId

    this.loadHistoryData()

    this.loadJobSignHistory()

    this.loadProducts();

    //設定一些欄位預設值
    this.formDefault()


    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
